import React from 'react';

import PropTypes from 'prop-types';

import { isArs } from '@src/utils/isArs';

import global from '@src/css/global.scss';


export const ArsKeyword = (props) => {
    const { title, children } = props;

    if (!isArs(title)) {
        return null;
    }

    if (children) {
        return <span>{children}<span className={global.lighter}> | </span>ARS</span>;
    }

    return (
        <span><span className={global.lighter}> | </span>ARS</span>
    );
};

ArsKeyword.propTypes = {
    children: PropTypes.node,
    title: PropTypes.string,
};
